import { createContext } from 'react'
import { MfePropsType } from '../types/mfeProps'
import { AppFCPropsWithChildrenType } from '../types/customReactTypes'

export type RootContext = AppFCPropsWithChildrenType & MfePropsType

const RootContext = createContext({} as RootContext)

export default RootContext
